import React from 'react';
import { iconStyle } from './styles';

export const Grad: React.FC<{ size?: string }> = ({ size }) => {
  return (
    <div style={iconStyle(size)}>
      <svg
        width="113px"
        height="113px"
        viewBox="0 0 113 113"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g transform="translate(-664.000000, -757.000000)">
            <g transform="translate(535.000000, 632.000000)">
              <g transform="translate(120.000000, 116.000000)">
                <g transform="translate(9.000000, 9.000000)">
                  <circle
                    fill="#17BFDD"
                    cx="56.5"
                    cy="56.5"
                    r="56.5"
                  ></circle>
                  <g
                    transform="translate(20.000000, 22.000000)"
                    stroke="#FFFFFF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <g transform="translate(2.242424, 16.969697)">
                      <path
                        d="M34.35126,0 L33.6664238,0 C22.5739123,5.89750755 11.2869561,9.44185775 0,15.1932236 L0,15.4276018 C4.32547417,17.1730302 8.61915237,18.9487899 12.9122191,20.6942183 L12.9122191,18.8600019 C18.9314399,16.3948945 26.1534042,13.4461407 34.7719451,13.476472 C43.3287285,13.5045974 50.7781562,16.2779811 56.7637466,18.8600019 C56.8291729,19.7986178 56.5674677,21.0603998 56.8939878,21.7938658 C59.1374377,20.663887 61.3821105,19.4760031 63.8224508,18.493269 L63.8224508,32.5940143 L62.6270449,32.5940143 L62.6270449,36.0606061 C63.8939918,35.5901952 63.5295611,34.710036 64.764712,34.2263897 C65.8708448,34.8572807 65.7338775,35.5753053 67.0014359,36.0606061 L67.0014359,32.5940143 C66.2218233,32.5206677 66.2621797,32.7699358 65.7094191,32.4771009 L65.7094191,17.3925185 C67.1066072,16.938652 68.1473136,16.1759577 69.5151515,15.6768699 L69.5151515,15.4276018 C68.2145743,14.7967108 35.4690105,0.861408902 34.3316933,0.0981631143"
                        id="Stroke-1"
                      ></path>
                      <path
                        d="M13.4545455,21.3127921 L13.4545455,27.5757576 C19.5568507,26.1122304 26.7796916,24.2331983 34.6702399,24.220377 C42.7011847,24.1956842 49.887773,26.1383479 56.0606061,27.5757576 L56.0606061,21.2121212"
                        id="Stroke-3"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};
